/**
 * Webhook Archetype
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeWebhookCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Webhook => Webhook_hijo respectivamente.
 * @date 16 de Oct, 2024
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date 16 de Oct, 2024
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'Webhook'

const baseIndex = baseController + '/index'

const archetype = () => {
    return [
        // [hidden|number|price|phone|textarea|positivo|password|email]
        { key: 'id', label: 'Number', type: 'input' },
        { key: 'request_get', type: 'hidden', label: 'Get', readonly: true },
        { key: 'request_post', type: 'hidden', label: 'Parámetros', readonly: true },
        [
            { key: 'estatus', type: 'select', options: procesadoFilterSample.options, readonly: !true },
            { key: 'origin', readonly: true },
            { key: 'origin_type', label: 'Tipo de orígen' }
        ],
        null,
        [
            { key: 'request_method', label: 'Metodo', readonly: true },
            { key: 'remote_addr', readonly: true },
        ],
        null,
        { key: 'processing_result', label: 'Resultado', type: 'textarea', readonly: true },
        null,
        { key: 'request_headers', type: 'textarea', readonly: true },
        null,
        { key: 'created', label: 'Fecha de creacion', readonly: true },
    ]
};

const captions = [
    { key: 'id' },
    // { key: 'usuario' },
    { key: 'estatus', label: 'Estatus' },
    { key: 'origin', label: 'Orígen' },
    { key: 'origin_type', label: 'Tipo' },
    { key: 'created', label: 'Fecha de creacion' },
    { key: 'processing_result', label: 'Resultado de procesamiento' },
    { key: '_' },
]

const captionsForSuscription = _.filter(captions, item => {
    let notInSuscription = [
        'usuario',
        'estatus',
    ];
    return (notInSuscription.indexOf(item.key) == -1)
})

const procesadoFilterSample = {
    key: 'estatus',
    required: true, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
    options: [
        'Nuevo',
        'Procesado'
    ],
    default: null,
};

const quicktableFilters = () => {
    return [
        procesadoFilterSample
    ]
}

const archetypeWebhookCFG = () => {
    return [
        // { key: 'id', type: 'hidden' },
        // { key: 'Webhook_id', type: 'hidden', },
        // { key: 'descriptor', label: 'Description', readonly: true },
    ]
};

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    captions, captionsForSuscription,
    baseIndex,
    archetype,
    archetypeWebhookCFG,
    quicktableFilters,
    automodalHandler
}